<!-- version 2021/05/20 -->
<template>
  <a class="btn" :class="{ disabled }" :href="disabled ? '' : link">{{ title }}</a>
</template>

<script>
export default {
  props: {
    title: String,
    link: String,
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="sass" scoped>
a
  border-radius: 6px !important
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08) !important
  background-color: #28c3cd !important
  color: #FFF !important
  &.disabled
    border-radius: 6px !important
    box-shadow: none !important
    background-color: #f8f8f8 !important
    color: #bcbcbc !important
a:hover
  background-color: #28c3cd !important
</style>
